import { PageBreak } from "app/components/layout/PageBreak";
import KeyIndicatorsContainer from "app/pages/industry-analysis/overview/widgets/key-indicators/single/KeyIndicatorsContainer";
import {
    MarketShareSectionTitle,
    MarketSizeSectionTitle,
    PageContainer,
} from "app/pages/industry-analysis/overview/Market-research-overview/layouts/styled";
import { TopPlayers } from "app/pages/industry-analysis/overview/Market-research-overview/top-players/TopPlayers";

import { ConversionRateOverviewContainer } from "../../widgets/conversion-rate/ConversionRateOverviewContainer";
import { ConversionRateLeaders } from "../../widgets/conversion-rate/single/leaders/ConversionRateLeaders";
import { HighLevelMetricsOvertime } from "../../widgets/high-level-metrics/single/HighLevelMetricsOvertime";

export const MarketResearchOverviewCustomWithSegments = () => {
    return (
        <PageContainer>
            <MarketSizeSectionTitle />
            <KeyIndicatorsContainer />
            <HighLevelMetricsOvertime />
            <PageBreak applyPageBreak />
            <ConversionRateOverviewContainer />
            <ConversionRateLeaders />

            <MarketShareSectionTitle />
            <TopPlayers />
        </PageContainer>
    );
};
